'use client';

import React, { useEffect, useRef } from 'react';

const services = [
{
  num: '01',
  title: 'Photography',
  desc: 'Every frame tells a story. We shoot with purpose, patience, and an eye for what makes your event unforgettable.',
  tags: ['Portraits', 'Events', 'Brand']
},
{
  num: '02',
  title: 'Videography',
  desc: 'Cinematic storytelling from concept to final cut. Brand films, reels, and social content built to move people.',
  tags: ['Brand Films', 'Reels', 'Social']
},
{
  num: '03',
  title: 'Live Production',
  desc: 'Seamless, high-energy production from setup to stream — so you can focus on the moment.',
  tags: ['Multi-Cam', 'Streaming', 'Events']
},
{
  num: '04',
  title: 'Branding',
  desc: 'Your brand is more than a logo. We craft the full visual language that makes people stop and take notice.',
  tags: ['Logo', 'Visual Identity', 'Design']
}];


export default function ServicesPreview() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.1 }
    );
    sectionRef?.current?.querySelectorAll('.reveal-on-scroll')?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      id="services"
      style={{ background: '#0C0C0C', padding: '100px 64px' }}>

      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="reveal-on-scroll mb-16 flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <div className="section-label">WHAT WE DO</div>
            <h2
              className="text-white"
              style={{
                fontFamily: 'Bebas Neue, sans-serif',
                fontSize: 'clamp(2.5rem, 5vw, 4.5rem)',
                lineHeight: 0.95,
                letterSpacing: '2px'
              }}>

              OUR SERVICES
            </h2>
          </div>
        </div>

        {/* Services grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px" style={{ border: '1px solid #1C1C1C' }}>
          {services?.map((svc, i) =>
          <div
            key={i}
            className={`reveal-on-scroll stagger-${i % 4 + 1} event-card group`}
            style={{ padding: '40px 32px', borderRight: '1px solid #1C1C1C', borderBottom: '1px solid #1C1C1C' }}>

              <span
              style={{
                fontFamily: 'Bebas Neue, sans-serif',
                fontSize: '12px',
                letterSpacing: '4px',
                color: '#FFFFFF',
                display: 'block',
                marginBottom: '16px'
              }}>

                {svc?.num}
              </span>
              <h3
              className="text-white group-hover:text-lime transition-colors duration-300"
              style={{
                fontFamily: 'Bebas Neue, sans-serif',
                fontSize: '28px',
                letterSpacing: '2px',
                marginBottom: '12px'
              }}>

                {svc?.title}
              </h3>
              <p
              style={{
                fontFamily: 'DM Sans, sans-serif',
                fontSize: '14px',
                color: 'rgba(255,255,255,0.5)',
                lineHeight: 1.65,
                marginBottom: '20px'
              }}>

                {svc?.desc}
              </p>
              <div className="flex flex-wrap gap-2">
                {svc?.tags?.map((tag, ti) =>
              <span
                key={ti}
                style={{
                  fontFamily: 'DM Sans, sans-serif',
                  fontSize: '11px',
                  letterSpacing: '1.5px',
                  color: 'rgba(255,255,255,0.4)',
                  border: '1px solid #1C1C1C',
                  padding: '4px 10px',
                  textTransform: 'uppercase'
                }}>

                    {tag}
                  </span>
              )}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

}